import React, {useMemo} from 'react'
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {lighten, makeStyles} from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import ReactExport from '@ibrahimrahmani/react-export-excel'
import {Button, Grid} from '@material-ui/core';
import {isFirebaseTimestamp} from "../../shared/functions/types_check";
import { jsPDF } from "jspdf";
import "jspdf-autotable";


const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;


const useToolbarStyles = makeStyles((theme) => ({
    root: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(1),
    },
    highlight:
        theme.palette.type === 'light'
            ? {
                color: theme.palette.primary.main,
                backgroundColor: lighten(theme.palette.primary.light, 0.85),
            }
            : {
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.primary.dark,
            },
    title: {
        flex: '1 1 100%',
    },
}));

const ReceivingResumeToolBar = (props) => {
    const classes = useToolbarStyles();

    const {numSelected, selectedItem, totalCount, data} = props;
    console.log(selectedItem)
    const formatted = useMemo(() => {
        return selectedItem.map(one => {
            return {
                ...one,
                id: one?.ItemId,
                Haschilds: Number(Boolean(one.Haschilds)),
                BuyPrice: (one.SellPrice / 1.5),
                ExpirationDate: isFirebaseTimestamp(one?.ExpirationDate) ? one?.ExpirationDate?.toDate() : null
            }
        })
    }, [selectedItem])

    const all = useMemo(() => {
        return data.map(one => {
            return {
                ...one,
                id: one?.ItemId,
                Haschilds: Number(Boolean(one.Haschilds)),
                BuyPrice: (one.SellPrice / 1.5),
                ExpirationDate: isFirebaseTimestamp(one?.ExpirationDate) ? one?.ExpirationDate?.toDate() : null
            }
        })
    }, [data])

    const detail = useMemo(() => {
        return data.map(one => {
            return {
                ...one,
                id: one?.ItemId,
                Haschilds: Number(Boolean(one.Haschilds)),
                BuyPrice: (one.SellPrice / 1.5),
                ExpirationDate: isFirebaseTimestamp(one?.ExpirationDate) ? one?.ExpirationDate?.toDate() : null

            }
        })
    }, [data])

    const createPDF = async () => {
        // TODO
         
        const unit = "pt";
        const size = "A4"; // Use A1, A2, A3 or A4
        const orientation = "portrait"; // portrait or landscape

        const marginLeft = 40;
        const doc = new jsPDF(orientation, unit, size);

        doc.setFontSize(15);

        const title = "My Awesome Report";
        const headers = [["Image","InternalId", "ItemBarcode", "ShippedQuantity", "Quantity"]];
        

        const data = formatted.map(elt=> [elt.ItemImageUrl, elt.InternalId, elt.ItemBarcode, elt.ShippedQuantity, elt.Quantity]);

        let content = {
        startY: 50,
        head: headers,
        body: data,
        didDrawCell: function(data) {
            if (data.column.index === 0 && data.cell.section === 'body') {
               var td = data.cell.raw;
               //var img = td.getElementsByTagName('img')[0];
               var dim = data.cell.height - data.cell.padding('vertical');
               var textPos = data.cell.textPos;
               doc.addImage(data.ItemImageUrl, textPos.x,  textPos.y, dim, dim);
            }
          }
        };

        doc.text(title, marginLeft, 40);
        doc.autoTable(content);
        doc.save("report.pdf")
    };  

    console.log(data?.find(one => one?.ItemId === "ZVAPSqLrkeuR4qbi2gyn"))


    return (
        <>
            <Toolbar className={clsx(classes.root, {[classes.highlight]: numSelected > 0})}>
                {numSelected > 0 ? (
                    <Grid container className={classes.title}>
                        <Grid>
                            <Button style={{marginRight: 20}}> {"Séléctionnés : " + numSelected} </Button>
                        </Grid>
                        <Grid>
                            <ExcelFile element={<Button style={{backgroundColor: "green", color: "white"}}>Exporter en
                                excel</Button>}>
                                <ExcelSheet data={formatted} name="Reciving">
                                    <ExcelColumn label="Code article" value="InternalId"/>
                                    <ExcelColumn label="Référence" value=""/>
                                    <ExcelColumn label="Code barre" value="ItemBarcode"/>
                                    <ExcelColumn label="Nom article" value="ItemName"/>
                                    <ExcelColumn label="Description" value="Description"/>
                                    <ExcelColumn label="Qté achat" value="ShippedQuantity"/>
                                    <ExcelColumn label="Qté compté" value="Quantity"/>
                                    <ExcelColumn label="Prix stock price" value="NewL"/>
                                    <ExcelColumn label="Prix achat" value="BuyPrice"/>
                                    <ExcelColumn label="Prix de vente" value="SellPrice"/>
                                    <ExcelColumn label="Pack" value="Haschilds"/>
                                    <ExcelColumn label="Classe" value="ItemClsass"/>
                                    <ExcelColumn label="Seuil de réapprovisionnement" value="Threshold"/>
                                    <ExcelColumn label="No de lot" value=""/>
                                    <ExcelColumn label="Date d'expiration" value="ExpirationDate"/>
                                </ExcelSheet>
                            </ExcelFile>
                            <ExcelFile
                                element={<Button style={{backgroundColor: "green", color: "white", marginLeft: 10}}>Exporter
                                    Tout en
                                    excel</Button>}>
                                <ExcelSheet data={all} name="Reciving">
                                    <ExcelColumn label="Code article" value="InternalId"/>
                                    <ExcelColumn label="Référence" value=""/>
                                    <ExcelColumn label="Code barre" value="ItemBarcode"/>
                                    <ExcelColumn label="Nom article" value="ItemName"/>
                                    <ExcelColumn label="Description" value="Description"/>
                                    <ExcelColumn label="Qté achat" value="ShippedQuantity"/>
                                    <ExcelColumn label="Qté compté" value="Quantity"/>
                                    <ExcelColumn label="Prix achat" value="BuyPrice"/>
                                    <ExcelColumn label="Prix de vente" value="SellPrice"/>
                                    <ExcelColumn label="Pack" value="Haschilds"/>
                                    <ExcelColumn label="Classe" value="ItemClsass"/>
                                    <ExcelColumn label="Seuil de réapprovisionnement" value="Threshold"/>
                                    <ExcelColumn label="No de lot" value=""/>
                                    <ExcelColumn label="Date d'expiration" value="ExpirationDate"/>
                                </ExcelSheet>
                            </ExcelFile>

                            <ExcelFile
                                element={<Button style={{backgroundColor: "green", color: "white", marginLeft: 10}}>Detail</Button>}>
                                <ExcelSheet data={detail} name="Reciving">
                                    <ExcelColumn label="Code article" value="InternalId"/>
                                    <ExcelColumn label="Référence" value=""/>
                                    <ExcelColumn label="Code barre" value="ItemBarcode"/>
                                    <ExcelColumn label="Nom article" value="ItemName"/>
                                    <ExcelColumn label="Description" value="Description"/>
                                    <ExcelColumn label="Qté achat" value="ShippedQuantity"/>
                                    <ExcelColumn label="Qté compté" value="Quantity"/>
                                    <ExcelColumn label="Prix achat" value="BuyPrice"/>
                                    <ExcelColumn label="Prix de vente" value="SellPrice"/>
                                    <ExcelColumn label="Pack" value="Haschilds"/>
                                    <ExcelColumn label="Classe" value="ItemClsass"/>
                                    <ExcelColumn label="Seuil de réapprovisionnement" value="Threshold"/>
                                    <ExcelColumn label="No de lot" value=""/>
                                    <ExcelColumn label="Date d'expiration" value="ExpirationDate"/>
                                </ExcelSheet>
                            </ExcelFile>
                            <Button onClick={createPDF} style={{backgroundColor: "red", color: "white", marginLeft: 10}}>Exporter En PDF</Button>
                        </Grid>
                    </Grid>
                ) : (
                    <Grid container>
                        <Grid item>
                            <Typography className={classes.title} color='primary'
                                        variant="h6" id="tableTitle" component="div">
                                RESUME DES RECEPTIONS
                            </Typography>
                        </Grid>
                        <Grid item>
                            {totalCount && <Typography className={classes.title} color='primary'
                                                       variant="h6" id="tableTitle" component="div">
                                {totalCount}
                            </Typography>}
                        </Grid>
                    </Grid>
                )}
            </Toolbar>
        </>
    );
};

ReceivingResumeToolBar.propTypes = {
    numSelected: PropTypes.number.isRequired,
    selectedItem: PropTypes.array.isRequired,
    setSelected: PropTypes.func.isRequired,
};


export default ReceivingResumeToolBar